"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumEventStatusesEnum = void 0;
var EnumEventStatusesEnum;
(function (EnumEventStatusesEnum) {
    EnumEventStatusesEnum["Draft"] = "draft";
    EnumEventStatusesEnum["Published"] = "published";
    EnumEventStatusesEnum["Completed"] = "completed";
    EnumEventStatusesEnum["Cancelled"] = "cancelled";
})(EnumEventStatusesEnum = exports.EnumEventStatusesEnum || (exports.EnumEventStatusesEnum = {}));
//# sourceMappingURL=eventStatuses.js.map